import { useState } from "react";
import { reviewData } from "@/mocks/homeData";

export default function ReviewSection() {
  const [current, setCurrent] = useState(0);
  const total = reviewData.reviews.length;

  const prev = () => setCurrent((p) => (p === 0 ? total - 1 : p - 1));
  const next = () => setCurrent((p) => (p === total - 1 ? 0 : p + 1));

  const review = reviewData.reviews[current];

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-0 max-w-6xl mx-auto">
          {/* Left: Avatar */}
          <div className="lg:w-[40%]">
            <div className="relative w-full h-[300px] md:h-[400px] lg:h-[500px] rounded-2xl overflow-hidden bg-accent-100">
              <img
                src={review.avatar}
                alt={review.author}
                className="w-full h-full object-cover object-top"
                title={review.author}
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-[60%] lg:pl-12 flex flex-col justify-center">
            <span className="text-xs md:text-sm text-accent-500 font-medium tracking-wider">
              （{reviewData.tag}）
            </span>

            <h2 className="mt-2 font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              {reviewData.title}
              <br />
              <span className="text-foreground-400">{reviewData.titleHighlight}</span>
            </h2>

            <blockquote className="mt-8 md:mt-10 text-base md:text-lg text-foreground-700 leading-relaxed italic border-l-2 border-primary-400 pl-5">
              &ldquo;{review.quote}&rdquo;
            </blockquote>

            <div className="mt-8 flex items-center gap-3">
              <div className="w-8 h-0.5 bg-foreground-900"></div>
              <span className="text-sm font-semibold text-foreground-900">—— {review.author}</span>
            </div>

            {/* Navigation arrows */}
            <div className="mt-10 flex items-center gap-3">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:border-foreground-900 hover:text-foreground-900 transition-colors cursor-pointer"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="ml-2 text-xs text-foreground-500">
                {current + 1}/{total}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}